import { ReactNode } from 'react'; 
import styles from './Layout.module.scss';

const Layout = ({ children }: { children: ReactNode }) => {
  return <article className={styles.container}>{children}</article>;
};

export default Layout;
